import React, { Component } from 'react'
import { steel, silver } from '@rover/react-bootstrap'

class ListCell extends Component {
    constructor(props) {
        super(props)
        this.state = {
            underline: false,
        }
        this.handleCellOver = this.handleCellOver.bind(this)
    }

    handleCellOver(val) {
        this.setState({
            underline: val,
        })
    }

    render() {
        const { underline } = this.state
        const { item, value, index, length } = this.props
        let displayValue = item
        if (value.value === '') {
            displayValue = 'Unknown'
        }
        return (
            <div
                style={{
                    display: 'inline',
                    cursor: 'pointer',
                    textDecoration: underline ? 'underline' : 'none',
                    color: displayValue === 'Unknown' ? silver : steel,
                }}
                onMouseOver={() => this.handleCellOver(true)}
                onMouseLeave={() => this.handleCellOver(false)}
                onClick={() => this.props.onCellSelected(value, [item])}
            >
                {displayValue}
                {index != length - 1 && <div style={{ display: 'inline' }}>, </div>}
            </div>
        )
    }
}

export default ListCell
